import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { SubtractNRI } from './types';
import { verificationStateAtomFamily } from 'lib/atoms/verification';

/**
 * Derived atom family that computes rollup verification data for a slot's subtracts.
 * Reads from verificationStateAtomFamily for each subtract to get current status,
 * falling back to initial status from the subtract data.
 */
export const rollupVerificationAtomFamily = atomFamily(
  ({ subtracts, type }: { subtracts: SubtractNRI[]; type: 'nri' | 'wi' }) =>
    atom((get) => {
      const totalSteps = subtracts.length;
      let markedCorrectTotal = 0;
      let markedIncorrectTotal = 0;

      subtracts.forEach((s) => {
        const atomKey = `${s.nriCalculationId}-${type}`;
        const persistedState = get(verificationStateAtomFamily(atomKey));
        const initialStatus =
          type === 'nri'
            ? s.verifications?.nri.status
            : s.verifications?.workingInterest.status;
        const status =
          persistedState !== null ? persistedState.status : initialStatus;

        if (status === true) {
          markedCorrectTotal++;
        } else if (status === false) {
          markedIncorrectTotal++;
        }
      });

      return { totalSteps, markedCorrectTotal, markedIncorrectTotal };
    }),
  (a, b) =>
    a.type === b.type &&
    a.subtracts.map((s) => s.nriCalculationId).join(',') ===
      b.subtracts.map((s) => s.nriCalculationId).join(',')
);

// Function to clear all verification state entries using setShouldRemove
// This clears both verificationStateAtomFamily and rollupVerificationAtomFamily
export const clearNriTableVerificationState = () => {
  verificationStateAtomFamily.setShouldRemove(() => true);
  verificationStateAtomFamily.setShouldRemove(null);
  rollupVerificationAtomFamily.setShouldRemove(() => true);
  rollupVerificationAtomFamily.setShouldRemove(null);
};
